import { Select } from 'antd';
import CleanField from 'components/Input/components/CleanField';
import { MultiSelectProps } from 'components/Input/types';
import { I18nContext } from 'contexts/I18n/I18nProvider';
import React, { useContext, useState } from 'react';

function handleChange(selectedValue: Array<string>, setValue: React.Dispatch<React.SetStateAction<Array<string>>>) {
  setValue(selectedValue)
}

export default function Multiselect({ options, value, labelParams, setValue }: MultiSelectProps) {
  const [dropdownVisible, setDropdownVisible] = useState(false)
  const [isFocused, setIsFocused] = useState(false)
  const t = useContext(I18nContext)

  return (
    <>
      <div className="multiselect-input-container">
        {labelParams && <div className="multiselect-label">
          <div className={(dropdownVisible || isFocused || value.length) ? 'floating' : 'fixed'}>
            <span style={{ paddingRight: '.2rem' }}>{t(labelParams.i18nTag)}</span>
            {labelParams.onClean && value.length > 0 && <span className="has-padding-top-xxs input-wrap-tooltip">
              <CleanField onClean={labelParams.onClean} />
            </span>}
          </div>
        </div>}
        <Select
          mode="multiple"
          maxTagCount={'responsive'}
          value={value}
          onChange={(value) => handleChange(value, setValue)}
          options={options.map(option => ({ label: t(option.label), value: option.value }))}
          onDropdownVisibleChange={(isOpen) => setDropdownVisible(isOpen)}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          id="multiselect"
        />
      </div>
    </>
  )
}
